import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import './ModalForms.css';

const ServicesFiltersModal = ({
  isOpen,
  onClose,
  operators = [],
  types = [],
  initialDateFrom = '',
  initialDateTo = '',
  initialType = '',
  initialStatuses = ['Completo', 'Incompleto'],
  initialOperatorId = '',
  initialCurrency = '',
  onApply
}) => {
  const DEFAULT_STATUSES = ['Completo', 'Incompleto'];
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [type, setType] = useState('');
  const [statuses, setStatuses] = useState(DEFAULT_STATUSES);
  const [operatorId, setOperatorId] = useState('');
  const [currency, setCurrency] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setDateFrom(initialDateFrom || '');
    setDateTo(initialDateTo || '');
    setType(initialType || '');
    setStatuses(Array.isArray(initialStatuses) && initialStatuses.length ? initialStatuses : DEFAULT_STATUSES);
    setOperatorId(initialOperatorId === null || initialOperatorId === undefined ? '' : String(initialOperatorId));
    setCurrency(initialCurrency || '');
  }, [isOpen, initialDateFrom, initialDateTo, initialType, initialStatuses, initialOperatorId, initialCurrency]);

  const toggleStatus = (statusValue) => {
    setStatuses((prev) => {
      if (prev.includes(statusValue)) return prev.filter((item) => item !== statusValue);
      return [...prev, statusValue];
    });
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onApply?.({
      dateFrom,
      dateTo,
      type,
      statuses,
      operatorId,
      currency
    });
  };

  return (
    <Modal
      title="Filtrar"
      isOpen={isOpen}
      onClose={onClose}
      footer={(
        <div className="modal-footer">
          <div className="footer-actions">
            <button type="button" className="btn secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" form="services-filters-modal-form" className="btn">
              Aceptar
            </button>
          </div>
        </div>
      )}
    >
      <form id="services-filters-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Filtrar por fecha de salida (desde)
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          </label>
          <label>
            Filtrar por fecha de salida (hasta)
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </label>

          <label>
            Filtrar por tipo
            <select value={type} onChange={(e) => setType(e.target.value)}>
              <option value="">Todos</option>
              {(types || []).map((typeOption) => (
                <option key={typeOption} value={typeOption}>
                  {typeOption}
                </option>
              ))}
            </select>
          </label>

          <label>
            Filtrar por operador
            <select value={operatorId} onChange={(e) => setOperatorId(e.target.value)}>
              <option value="">Todos</option>
              {(operators || []).map((o) => (
                <option key={o.id} value={String(o.id)}>
                  {o.name}
                </option>
              ))}
            </select>
          </label>

          <label>
            Filtrar por moneda
            <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
              <option value="">Todas</option>
              <option value="USD">USD</option>
              <option value="$">$</option>
            </select>
          </label>

          <div className="status-filter-group">
            <div className="filter-field-label">Filtrar por estado</div>
            <div className="status-filter-options">
              {['Completo', 'Incompleto', 'Deprecado'].map((statusOption) => (
                <label key={statusOption} className="status-filter-option">
                  <input
                    type="checkbox"
                    checked={statuses.includes(statusOption)}
                    onChange={() => toggleStatus(statusOption)}
                  />
                  {statusOption}
                </label>
              ))}
            </div>
          </div>
        </div>

      </form>
    </Modal>
  );
};

export default ServicesFiltersModal;

